// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_dompurify_dist_purify_es_mjs":"d0489752400c232b","node_modules_canvg_lib_index_es_js":"5ff0b3c7f96920e6"}[chunkId] + ".js";
};